import { Stack } from '@mui/material'
import { ComponentFinder } from '../v2/componentFinder'
import { SectionV2Provider } from '../v2/state/sectionProvider'

export interface INextComponent {
    date: string
    data: any
    sortDate: string
    renderOptions: any
}
type INextProps = {
    components: INextComponent[]

    past?: boolean
}

export default function Next({ components, past }: INextProps) {
    const sortSubcards = (a: any, b: any) => {
        if (a.data.subCard && !b.data.subCard) {
            return -1
        }
        if (!a.data.subCard && b.data.subCard) {
            return 1
        }
        return 0
    }

    return (
        <Stack padding={'0px 8px'}>
            {components.sort(sortSubcards).map((comp, index) => {
                return comp.renderOptions.rendererOptions.components.map(
                    (com: any, index2: number) => {
                        return (
                            <SectionV2Provider
                                sectionData={comp.renderOptions}
                                isPublic={comp.data._og_code}
                                key={index2}
                            >
                                <ComponentFinder
                                    key={[index, index2].join('-')}
                                    renderOptions={com}
                                    data={comp.data}
                                    componentKey={com.componentKey}
                                    isInPast={past}
                                />
                            </SectionV2Provider>
                        )
                    }
                )
            })}
        </Stack>
    )
}
